module.exports = __webpack_public_path__ + "img/t_logo.1f75d678.png";